// Confetti ke saath bajne wali chhoti celebration awaaz (~1 second): ek halka
// "pop" aur uske baad chadhte hue chaar sur + ek chamak.
//
// Koi audio file nahi — Web Audio API se wahin banti hai, isliye download
// kuch nahi hota.
//
// Browser ka niyam: page pe user ke kisi tap/click se pehle awaaz bajane ki
// ijazat aksar nahi hoti (khaas kar phone pe, aur jab user kisi doosri site —
// jaise Stripe checkout — se laut kar aaya ho). Us haal me AudioContext
// "suspended" rehta hai. Tab hum user ke pehle tap/key ka intezaar karte hain
// aur usi pal bajate hain — par sirf GESTURE_WINDOW_MS ke andar, warna der se
// bajti awaaz confetti se judi nahi lagti.
const GESTURE_WINDOW_MS = 5000;
const GESTURE_EVENTS = ["pointerdown", "touchstart", "keydown"];

const scheduleSound = (ctx) => {
  const now = ctx.currentTime;
  const master = ctx.createGain();
  master.gain.value = 0.5;
  master.connect(ctx.destination);

  // "Pop": bahut chhota shor, bandpass se gol kiya hua.
  const popLength = Math.floor(ctx.sampleRate * 0.12);
  const buffer = ctx.createBuffer(1, popLength, ctx.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < popLength; i += 1) data[i] = Math.random() * 2 - 1;
  const pop = ctx.createBufferSource();
  pop.buffer = buffer;
  const popFilter = ctx.createBiquadFilter();
  popFilter.type = "bandpass";
  popFilter.frequency.value = 1800;
  const popGain = ctx.createGain();
  popGain.gain.setValueAtTime(0.6, now);
  popGain.gain.exponentialRampToValueAtTime(0.001, now + 0.12);
  pop.connect(popFilter).connect(popGain).connect(master);
  pop.start(now);

  // Chadhte sur (C5, E5, G5, C6), phir upar ek halki chamak (C7).
  const tone = (frequency, start, duration, peak, type) => {
    const osc = ctx.createOscillator();
    osc.type = type;
    osc.frequency.value = frequency;
    const gain = ctx.createGain();
    gain.gain.setValueAtTime(0.0001, now + start);
    gain.gain.exponentialRampToValueAtTime(peak, now + start + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + start + duration);
    osc.connect(gain).connect(master);
    osc.start(now + start);
    osc.stop(now + start + duration + 0.02);
  };
  [523.25, 659.25, 783.99, 1046.5].forEach((frequency, i) => {
    tone(frequency, 0.05 + i * 0.09, 0.5, 0.22, "triangle");
  });
  tone(2093, 0.42, 0.45, 0.08, "sine");

  // Sab baj chukne ke baad audio device chhod do.
  setTimeout(() => ctx.close().catch(() => {}), 1600);
};

export const playCelebrationSound = () => {
  const AudioContextClass =
    typeof window !== "undefined" && (window.AudioContext || window.webkitAudioContext);
  if (!AudioContextClass) return;

  let ctx;
  try {
    ctx = new AudioContextClass();
  } catch {
    return;
  }

  let done = false;
  const removeListeners = () => {
    GESTURE_EVENTS.forEach((name) => window.removeEventListener(name, onGesture, true));
  };
  const play = () => {
    if (done || ctx.state !== "running") return;
    done = true;
    removeListeners();
    scheduleSound(ctx);
  };
  function onGesture() {
    ctx.resume().then(play).catch(() => {});
  }

  if (ctx.state === "running") {
    play();
    return;
  }

  // Ijazat nahi mili: pehle tap/key pe bajao, par sirf thodi der tak.
  GESTURE_EVENTS.forEach((name) => window.addEventListener(name, onGesture, true));
  ctx.resume().then(play).catch(() => {});
  setTimeout(() => {
    if (done) return;
    done = true;
    removeListeners();
    ctx.close().catch(() => {});
  }, GESTURE_WINDOW_MS);
};

export default playCelebrationSound;
